import { render, staticRenderFns } from "./QuitTipModal.vue?vue&type=template&id=649bf9fb&scoped=true&"
import script from "./QuitTipModal.vue?vue&type=script&lang=js&"
export * from "./QuitTipModal.vue?vue&type=script&lang=js&"
import style0 from "./QuitTipModal.vue?vue&type=style&index=0&id=649bf9fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649bf9fb",
  null
  
)

export default component.exports